import { IRestructuredContactsByPhoneNumberActions } from './actions';
import {
    IRestructuredContactsByPhoneNumberActionTypes,
    IRestructuredDirectoryContactsState,
} from './types';

const defaultState: IRestructuredDirectoryContactsState = {
    contactsWithKeyAsPhoneNumber: {},
    isProcessing: undefined,
};

const restructuredDirectoryContactsReducer = (
    state = defaultState,
    action: IRestructuredContactsByPhoneNumberActions
) => {
    switch (action.type) {
        case IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER:
            return { ...state, contactsWithKeyAsPhoneNumber: action.payload };

        case IRestructuredContactsByPhoneNumberActionTypes.SET_RESTRUCTURED_CONTACTS_BY_PHONE_NUMBER_PROCESSING:
            return { ...state, isProcessing: action.payload };

        default:
            return state;
    }
};

export default restructuredDirectoryContactsReducer;
